module.exports = __webpack_public_path__ + "img/dash-customer-img.18f64d32.svg";